<template>
    <div>试题库</div>
</template>

<script>
    export default {
        name: "Questions"
    }
</script>

<style scoped>

</style>